export default __webpack_public_path__ + "static/media/zago.5e3d48f3.jpg";